import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, WHATSAPP_URL } from "./data";
import { PageFooter, Corner } from "./chrome";

export default function ContactPage() {
  return (
    <section className="page contact-page" data-testid="page-contact">
      <div className="grain" />
      <Corner section="VII · Contact" />
      <div className="page-inner">
        <div className="section-header">
          <div className="eyebrow">Get a Free Survey</div>
          <h2 className="h-title">
            For consultation,<br /><em>contact us.</em>
          </h2>
        </div>

        <p className="body" style={{ maxWidth: "70%" }}>
          Speak directly with our Director, <strong>Santhosha Kumar R</strong>, to design the right solar system for your home, factory or office. Free rooftop survey, no commitment.
        </p>

        <div className="contact-grid">
          <div className="contact-card">
            <div className="icon-row">
              <div className="contact-icon"><Phone size={18} /></div>
              <div className="small-label">Direct Line</div>
            </div>
            <h4>Talk to our Director</h4>
            <p>
              Santhosha Kumar R<br />
              <a href={`tel:${PHONE_TEL}`} data-testid="contact-phone">{PHONE_DISPLAY}</a>
            </p>
          </div>

          <div className="contact-card">
            <div className="icon-row">
              <div className="contact-icon"><MessageCircle size={18} /></div>
              <div className="small-label">WhatsApp</div>
            </div>
            <h4>Chat With Us</h4>
            <p>
              Fast replies, photo &amp; video sharing<br />
              <a href={WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid="contact-whatsapp">
                {PHONE_DISPLAY}
              </a>
            </p>
          </div>

          <div className="contact-card">
            <div className="icon-row">
              <div className="contact-icon"><Mail size={18} /></div>
              <div className="small-label">Enquiries</div>
            </div>
            <h4>Email Our Team</h4>
            <p>
              For quotes, BOQs and site visits<br />
              <a href="mailto:info@inpacepowers.com">info@inpacepowers.com</a>
            </p>
          </div>

          <div className="contact-card">
            <div className="icon-row">
              <div className="contact-icon"><MapPin size={18} /></div>
              <div className="small-label">Headquarters</div>
            </div>
            <h4>Visit Our Office</h4>
            <p>
              INPACE POWER<br />
              Bangalore, Karnataka, India<br />
              <a href="https://inpacepowers.com" target="_blank" rel="noreferrer">inpacepowers.com</a>
            </p>
          </div>
        </div>

        <div className="cta-band">
          <div>
            <h4>Ready for your <em>free rooftop survey?</em></h4>
            <p>Call now and our team will schedule a site visit within 48 hours.</p>
          </div>
          <a className="cta-phone" href={`tel:${PHONE_TEL}`} data-testid="cta-phone">{PHONE_DISPLAY}</a>
        </div>
      </div>
      <PageFooter num="16" />
    </section>
  );
}
